import { gql, useQuery } from '@apollo/client';

export const GET_SALARY_TYPES_BY_IDS = gql`
  query getSalaryTypesByIds($ids: [String!]!) {
    getSalaryTypesByIds(ids: $ids) {
      _id
      name
    }
  }
`;
export const useGetSalaryTypesByIds = (ids?: string[]) => {
  const { data, loading } = useQuery(GET_SALARY_TYPES_BY_IDS, {
    variables: {
      ids,
    },
    skip: !ids?.length,
    fetchPolicy: 'cache-and-network',
  });

  return {
    healthInsurance: data?.getSalaryTypesByIds || [],
    loading,
  };
};
